import React from 'react';

import { NoImageSvg } from '@assets';

import './style.scss';

const PREVIEW_DISPLAY_MAX = 4;

interface RecentSearchPreviewGridProps {
  urls?: string[];
  /** Cars only: supplier logo per cell (same index as urls), bottom-right overlay. */
  overlayUrls?: (string | undefined)[];
}

export const RecentSearchPreviewGrid: React.FC<RecentSearchPreviewGridProps> = ({
  urls,
  overlayUrls,
}) => {
  const images = (urls ?? []).slice(0, PREVIEW_DISPLAY_MAX).filter(Boolean);
  const count = images.length;
  const hasCarLogos = Boolean(overlayUrls?.some((u) => typeof u === 'string' && u.length > 0));

  const countClass =
    count <= 1
      ? 'recent-searches__preview--1'
      : count === 2
        ? 'recent-searches__preview--2'
        : count === 3
          ? 'recent-searches__preview--3'
          : 'recent-searches__preview--4';

  return (
    <div
      className={`recent-searches__preview ${countClass}${hasCarLogos ? ' recent-searches__preview--car-logos' : ''}`}
      aria-hidden
    >
      {count === 0 ? (
        <div className="recent-searches__preview-cell recent-searches__preview-cell--default">
          <NoImageSvg />
        </div>
      ) : (
        images.map((src, i) => (
          <div key={`${src}-${i}`} className="recent-searches__preview-cell">
            <img src={src} alt="" loading="lazy" />
            {overlayUrls?.[i] ? (
              <span className="recent-searches__preview-logo-wrap" aria-hidden>
                <img src={overlayUrls[i]} alt="" className="recent-searches__preview-logo" loading="lazy" />
              </span>
            ) : null}
          </div>
        ))
      )}
    </div>
  );
};
